import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Support: the Tickets this workspace has opened, and each one's conversation. */
export const Route = createFileRoute("/_app/support")({ component: Outlet });
